import { TabData } from '@ddt-web/data-service';

/**
 * DOUGHNUT_CHART_CONFIG: a JSON object representing a schema used to drive doughnut charts for HighCharts.
 */
declare const Highcharts;

export const IQ_DOUGHNUT_CHART_CONFIG = (tabData: TabData) => ({
	chart: {
		margin: 0,
		spacingRight: 90,
		marginLeft: -230,
		marginTop: -35,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: null
		},
		type: 'pie'
	},
	plotOptions: {
		pie: {
			dataLabels: {
				enabled: false
			},
			innerSize: '80%',
			startAngle: 0,
			endAngle: 360,
			size: '130px',
			showInLegend: true
		}
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#a5a5a5',
		borderRadius: 0,
		shadow: false,
		useHTML: true,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		},
		formatter: function (): string {
			let tooltip = '';
			const headersY = tabData?.tableData?.[0]?.headersY || [];
			const index = headersY?.findIndex(x => x?.formattedValue === this.point.category);

			const headerY = tabData.tableData[0].headersY[index];
			if (headerY?.children?.length) {
				const fundsCellData = tabData?.tableData[0]?.cells.map(cell => cell.find(x => x.config.id === 'totalFunds'))?.[index];
				const percentageCellData = tabData?.tableData[0]?.cells.map(cell => cell.find(x => x.config.id === 'fundsPercentage'))?.[index];

				const tableRowsData = headerY?.children.reduce((acc, cell, index) => {
					const fundCellValue = +fundsCellData?.children?.[index]?.formattedValue;
					const percentageCellValue = percentageCellData?.children?.[index]?.formattedValue;

					return acc + `<tr>
		                <td class="text-align-left text-12"> ${cell?.formattedValue}</td> 
						<td class="padding-right-20">${fundCellValue}</td> 
						<td>${percentageCellValue}</td> 
						</tr>`;
				}, '');

				tooltip =
					`<div style="width:230px;"> 
					   <table width="100%" class="text-align-right">
			              <tr>
			                <th class="text-12-bold text-align-left">${this.point.category}</th>
				            <th class="padding-right-20 text-bold">Funds</th>
				            <th class="text-bold">%</th>
			            </tr>
				        <tr>
				            <td style="border-top:1px solid black;" colspan="3"></td>
				        </tr>
				        ${tableRowsData}
				       </table> 
				    </div>`;
			}
			else {
				tooltip =
					`<div style="width:120px;"> 
				       <table width="100%"> 
					     <thead>
					      <tr>
					        <th colspan="3" class="text-12-bold"> ${this.point.name}</th>
						  </tr>
					     </thead> 
					     <tbody>
					      <tr> 
					        <td class="text-align-left"> 
					             ${this.point.y} Funds  
					        </td> 
					        <td class="text-align-center"> | </td> 
					        <td class="text-align-right">  
					             ${Highcharts.numberFormat(this.point.percentage, 2, '.', ',') + '%'} 
					        </td> 
					       </tr> 
				       </tbody> 
					</table> 
				</div>`;
			}
			return tooltip;
		}
	},
	colors: null,
	title: {
		text: null,
		widthAdjust: null,
		style: {
			color: '#000000',
			fontFamily: 'FortBold, Arial, sans-serif'
		},
		align: 'center',
		verticalAlign: 'middle'
	},
	series: null,
	legend: {
		enabled: true,
		squareSymbol: true,
		layout: 'vertical',
		verticalAlign: 'top',
		align: 'right',
		symbolRadius: 0,
		symbolPadding: 15,
		itemMarginBottom: 15,
		symbolHeight: 14,
		itemStyle: {
			fontSize: '14px'
		}
	}
});
